import { render, staticRenderFns } from "./userExpeditingDelivery.vue?vue&type=template&id=5534216e&scoped=true"
import script from "./userExpeditingDelivery.vue?vue&type=script&lang=js"
export * from "./userExpeditingDelivery.vue?vue&type=script&lang=js"
import style0 from "./userExpeditingDelivery.vue?vue&type=style&index=0&id=5534216e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5534216e",
  null
  
)

export default component.exports